import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";
import { sizeButtonModalContained, sizeButtonModalOutlined } from "config/constants";
import React, { forwardRef } from "react";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export const DialogModal = ({
  open,
  onClose,
  title,
  textInfo,
  textAlert,
  onClickHandler,
  buttonName,
  buttonNameSecondary,
  showCancel,
  loading,
  maxWidth = "sm",
  fullWidth = false,
}) => {
  const handleCloseprev = (e, reason) => {
    if (reason && (reason === "backdropClick" || reason === "escapeKeyDown"))
      return;
    onClose();
  };

  return (
    <Dialog
      sx={{
        "&.MuiDialog-root": {
          zIndex: 6000,
        },
        py: "30px",
        px: "32px",
        minWidth: 448
      }}
      open={open}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      TransitionComponent={Transition}
      // keepMounted
      onClose={handleCloseprev}
      aria-describedby="alert-dialog-slide-description" 
    >
      <DialogTitle sx={{ textAlign: "center" }}>{title}</DialogTitle>
      <DialogContent sx={{ textAlign: "center", paddingBottom: 1 }}>
        <DialogContentText id="alert-dialog-slide-description">
          {textInfo}
          <DialogContentText sx={{ color: "error.main", marginTop: 2 }}>
            {textAlert}
          </DialogContentText>
        </DialogContentText>
      </DialogContent>
      {/* <DialogActions> */}
      <Box
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        sx={{
          pb: "30px",
          px: "32px",
          minWidth: 448
        }}
      >
        {showCancel ? (
          <Button
            color="primary"
            sx={{
              mr: "12px",
              height: sizeButtonModalOutlined.height, width: sizeButtonModalOutlined.width, fontSize: sizeButtonModalOutlined.fontSize, fontWeight: sizeButtonModalOutlined.fontWeight
            }}
            variant="outlined"
            onClick={onClose}
          >
            {buttonNameSecondary ?? "Cancelar"}
          </Button>
        ) : (
          <></>
        )}

        <LoadingButton
          loading={loading}
          sx={{
            ml: "12px",
            height: sizeButtonModalContained.height, width: sizeButtonModalContained.width, fontSize: sizeButtonModalContained.fontSize, fontWeight: sizeButtonModalContained.fontWeight
          }}
          variant="contained"
          onClick={onClickHandler}
        >
          {buttonName ?? "Aceptar"}
        </LoadingButton>
      </Box>
      {/* </DialogActions> */}
    </Dialog>
  );
};
